<template>
    <div>
        <v-row class="ma-16 text-center">
          <v-col cols="12">
            <p class="text-h4">Regulamin Sklepu Online Alpakowy Raj - kołdry</p>
          </v-col>
        </v-row>
        <v-row class="mt-16 mb-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 1. Postanowienia ogólne</p>
            <p class="text-subtitle-1 font-weight-light">1. Niniejszy regulamin określa zasady korzystania ze sklepu internetowego prowadzonego przez Alpakowy Raj Paweł Milde(dalej: Sprzedawca).</p>
            <p class="text-subtitle-1 font-weight-light">2. Sklep oferuje produkty, w tym kołdry z wełny alpak.</p>
            <p class="text-subtitle-1 font-weight-light">3. Korzystanie ze Sklepu oznacza akceptację niniejszego regulaminu.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 2. Zamówienia i dostawy</p>
            <p class="text-subtitle-1 font-weight-light">1. Zamówienia można składać za pośrednictwem strony internetowej Sklepu.</p>
            <p class="text-subtitle-1 font-weight-light">2. W momencie złożenia zamówienia, Klient zobowiązuje się do zapłaty ceny produktów oraz kosztów dostawy.</p>
            <p class="text-subtitle-1 font-weight-light">3. Realizacja zamówienia oraz dostawa towarów odbywają się zgodnie z warunkami podanymi na stronie internetowej Sklepu.</p>
            <p class="text-subtitle-1 font-weight-light">4. Ceny produktów widoczne na stronie Sklepu są cenami brutto i zawierają podatek VAT.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 3. Płatności</p>
            <p class="text-subtitle-1 font-weight-light">1. Sklep umożliwia dokonywanie płatności za zamówienia za pomocą metody płatności: przelewem bankowym, płatności elektroniczne.</p>
            <p class="text-subtitle-1 font-weight-light">2. Klient jest zobowiązany do dokonania płatności za zamówienie w terminie podanym na stronie Sklepu.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 4. Zwroty i reklamacje</p>
            <p class="text-subtitle-1 font-weight-light">1. Klient ma prawo do zwrotu towaru w ciągu 14 dni od daty otrzymania zamówienia, zgodnie z przepisami prawa konsumenta.</p>
            <p class="text-subtitle-1 font-weight-light">2. Reklamacje dotyczące jakości produktów lub innych problemów z zamówieniem prosimy kierować na adres kontakt@alpakowyraj.pl. Klient zobowiązany jest do dostarczenia dokładnej informacji dotyczącej reklamacji oraz zdjęć przedstawiających ewentualne wady produktu.</p>
            <p class="text-subtitle-1 font-weight-light">3. Sprzedawca rozpatruje reklamacje i informuje Klienta o wynikach postępowania w terminie do 14 dni od daty otrzymania reklamacji.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 5. Ochrona danych osobowych</p>
            <p class="text-subtitle-1 font-weight-light">1. Dane osobowe Klienta są przetwarzane zgodnie z obowiązującymi przepisami prawa i Polityką Prywatności dostępną na stronie Sklepu.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <p class="text-h6">§ 6. Postanowienia końcowe</p>
            <p class="text-subtitle-1 font-weight-light">1. Regulamin obowiązuje od daty 02.11.2023r i jest dostępny na stronie internetowej Sklepu.</p>
            <p class="text-subtitle-1 font-weight-light">2. Sprzedawca zastrzega sobie prawo do zmiany regulaminu. Zmiany wchodzą w życie po ich opublikowaniu na stronie internetowej Sklepu.</p>
            <p class="text-subtitle-1 font-weight-light">3. Wszelkie spory związane z korzystaniem ze Sklepu będą rozstrzygane przez właściwy sąd.</p>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row class="mt-8 mx-16 text-center">
          <v-col cols="12">
            <p class="text-subtitle-1">Niniejszy regulamin stanowi podstawę współpracy między Sprzedawcą a Klientem. Zalecamy dokładne zapoznanie się z jego treścią przed dokonaniem zakupu w Sklepie.</p>
          </v-col>
        </v-row>
        <br />
    </div>
</template>